import * as React from 'react';
import { Konkurrence } from '../../models/Konkurrence';
import { DropDownFormGroup, MenuItemDto, TextFormGroup } from '../../uiComponents/input/FormGroups';
import { Bruger } from '../../models/Bruger';
import { Tilmelding } from '../../models/Tilmelding';
import { Hold } from '../../models/Hold';
import { Form, Row, Col, Button, } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import Moment from 'react-moment';
import { Section } from '../../uiComponents/layout/Section';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { ButtonSection } from '../../uiComponents/layout/ButtonSection';
import { ValidationResult, getValidationErrorsForCollection } from '../../infrastructure/ValidationResult';
import { ImageFromBlob } from '../../uiComponents/layout/ImageFromBlob';
import { RouteComponentProps } from 'react-router';
import { Modal } from '../../uiComponents/layout/Modal';
import SubmitButton from '../../uiComponents/input/SubmitButton';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import LaererComponent from './LaererComponent';
import { Laerer } from '../../models/Laerer';
import { Institution } from '../../models/Institution';
import * as FlipMove from 'react-flip-move';
import { KonkurrenceBeskrivelse } from '../../uiComponents/KonkurrenceBeskrivelse';
import { UniloginBruger } from '../../models/UniloginBruger';

export interface TilmeldHoldPresenterProps extends RouteComponentProps<any> {
    konkurrence: Konkurrence;
    primaerLaerer: Bruger;
    tilmelding: Tilmelding;
    holdListe: Hold[];
    validationResult: ValidationResult;
    isSubmitting: boolean;
    valgtInstitution: Institution;
    onTilmeldingSave: () => void;
    onTilmeldingChanged: (fieldName: string, value: any) => void;
    onLaererRemoved: (index: number) => void;
    onInvitationAdded: () => void;
    onTilmeldingDelete?: () => void;
    opretRediger: 'opret' | 'rediger';
    venteliste: boolean;
    onUniloginBrugerChanged?: (fieldName: string, value: string) => void;
    onGetDataForUnilogin?: () => void;
    uniloginDataFetched?: boolean;
    uniloginBruger?: UniloginBruger;
    isSubmittingUnilogin?: boolean;
}

class TilmeldHoldPresenter extends React.Component<TilmeldHoldPresenterProps, {}> {
    constructor(props: TilmeldHoldPresenterProps) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.onInvitationChanged = this.onInvitationChanged.bind(this);
        this.onInvitationRemoved = this.onInvitationRemoved.bind(this);
        this.onLaererChanged = this.onLaererChanged.bind(this);
        this.onLaererRemoved = this.onLaererRemoved.bind(this);
        this.getLaerere = this.getLaerere.bind(this);
        this.onUniloginBrugerChanged = this.onUniloginBrugerChanged.bind(this);
    }

    handleSubmit() {
        this.props.onTilmeldingSave();
    }

    onInvitationRemoved(index: number) {
        this.props.tilmelding.inviteredeLaerere.splice(index, 1);
        this.props.onTilmeldingChanged('inviteredeLaerere', this.props.tilmelding.inviteredeLaerere);
    }

    onInvitationChanged(field: string, value: any, index: number) {
        this.props.tilmelding.inviteredeLaerere[index][field] = value;
        this.props.onTilmeldingChanged('inviteredeLaerere', this.props.tilmelding.inviteredeLaerere);
    }

    onLaererRemoved(index: number) {
        this.props.tilmelding.inviteredeLaerere.splice(index, 1);
        this.props.onTilmeldingChanged('inviteredeLaerere', this.props.tilmelding.inviteredeLaerere);
    }

    onLaererChanged(field: string, value: any, index: number) {
        if (field === 'ansvarlig') {
            this.props.tilmelding.tilmeldteLaerere.forEach(t =>
                t.ansvarlig = false
            );
        } else {
            this.props.tilmelding.tilmeldteLaerere[index][field] = value;
        }
        this.props.tilmelding.tilmeldteLaerere[index][field] = value;
        this.props.onTilmeldingChanged('tilmeldteLaerere', this.props.tilmelding.tilmeldteLaerere);
    }

    getLaerere(laerere: Laerer[], collectionName: 'inviteredeLaerere' | 'tilmeldteLaerere'): JSX.Element[] {
        let c = 0;
        const laerereList: JSX.Element[] = new Array;
        const self = this;
        let sortedLaerere = laerere.sort((a: Laerer, b: Laerer) => {
            if (a.ansvarlig > b.ansvarlig) {
                return -1;
            }
            if (a.ansvarlig < b.ansvarlig) {
                return 1;
            }
            return 0;
        });
        sortedLaerere.forEach(laerer => {
            var errors = getValidationErrorsForCollection(self.props.validationResult.errorMessages, collectionName, c);

            const editable = laerer.brugerId === undefined;

            laerereList.push(
                <LaererComponent
                    key={laerer.uiId}
                    laerer={laerer}
                    validationErrors={errors}
                    onLaererChanged={collectionName === 'inviteredeLaerere' ? this.onInvitationChanged : this.onLaererChanged}
                    onLaererRemoved={collectionName === 'inviteredeLaerere' ? this.onInvitationRemoved : this.props.onLaererRemoved}
                    index={c}
                    editable={editable}
                    tilmeldteLaerere={this.props.tilmelding.tilmeldteLaerere}
                />
            );
            c = c + 1;
        });

        let laerereDiv: any = '';
        if (laerereList.length > 0) {
            laerereDiv = (
                <FlipMove enterAnimation='accordionVertical' leaveAnimation='accordionVertical'>
                    {laerereList}
                </FlipMove>
            );
        }

        return laerereDiv;
    }

    getRemarksSection() {
        let todayMonth = new Date().getMonth() + 1;
        let may = new Date(1, 4, 1).getMonth() + 1;
        let august = new Date(1, 7, 1).getMonth() + 1;
        let summer = may <= todayMonth && todayMonth < august;

        if (summer) {
            return (
                <Row>
                    <Col md={8}>
                        <b><u>BEMÆRK ved tilmelding før sommerferien</u></b>
                        <p>Vælg klasse ud fra de elever, som du ønsker skal deltage i Naturfagsmaraton. Hvis du fx ønsker at tilmelde 5.a efter sommerferien, så skal du vælge 4.a før sommerferien, så adgangen til systemet følger de enkelte elever.</p>
                        <i>Dette gælder kun ved tilmelding før sommerferien.</i>
                    </Col>
                </Row>
            );
        }

        return undefined;
    }

    onUniloginBrugerChanged(fieldName: string, value: string) {
        if (this.props.onUniloginBrugerChanged) {
            this.props.onUniloginBrugerChanged(fieldName, value);
        }
    }

    getUniloginSection() {
        if (this.props.opretRediger === 'opret' && getLoggedInBruger().rolle === BrugerRolleEnum.Administrator && this.props.uniloginBruger && this.props.onUniloginBrugerChanged) {
            return (
                <div>
                    <Row>
                        <Col md={8}>
                            <div className='error-message no-margin-top margin-bottom'>
                                <p>For tilmeding af Unilogin, skal felterne "Navn", "Email" og "Unilogin" udfyldes.</p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <TextFormGroup
                                errorMessages={[]}
                                label='Navn*'
                                name='navn'
                                placeholder='Skriv navn'
                                value={this.props.uniloginBruger.navn}
                                onChange={this.props.onUniloginBrugerChanged}
                            />
                        </Col>
                        <Col md={4}>
                            <TextFormGroup
                                errorMessages={[]}
                                label='Email*'
                                name='email'
                                placeholder='Skriv email'
                                value={this.props.uniloginBruger.email}
                                onChange={this.props.onUniloginBrugerChanged}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4}>
                            <TextFormGroup
                                errorMessages={[]}
                                label='Unilogin*'
                                name='brugernavn'
                                placeholder='Skriv unilogin'
                                value={this.props.uniloginBruger.brugernavn}
                                onChange={this.props.onUniloginBrugerChanged}
                            />
                        </Col>
                        <Col md={4} className='btn-hent-unilogin-info'>
                            <Button buttonType='secondary' onClick={this.props.onGetDataForUnilogin} disabled={!(this.props.uniloginBruger.brugernavn && this.props.uniloginBruger.navn && this.props.uniloginBruger.email) || this.props.isSubmittingUnilogin}>
                                {this.props.isSubmittingUnilogin === true ? 'Henter informationer...' : 'Hent UNI-login informationer'}
                            </Button>
                        </Col>
                    </Row>
                </div>
            )
        }

        return undefined;
    }

    render() {
        const uniloginDataMangler = this.props.opretRediger === 'opret' && getLoggedInBruger().rolle === BrugerRolleEnum.Administrator && this.props.uniloginDataFetched === false;

        const hold = uniloginDataMangler ? [] : this.props.holdListe.map(h => new MenuItemDto(h.gruppeId, h.navn));
        const institutioner = uniloginDataMangler ? [] : this.props.primaerLaerer.institutioner.map(i => new MenuItemDto(i.institutionsnummer, i.navn));
        const opgavepakker = this.props.konkurrence.opgavepakker.map(o => new MenuItemDto(o.id, o.titel));
        const inviteredeLaerere = this.getLaerere(this.props.tilmelding.inviteredeLaerere, 'inviteredeLaerere');
        const tilmeldteLaerere = this.getLaerere(this.props.tilmelding.tilmeldteLaerere, 'tilmeldteLaerere');

        let header = undefined;
        let saveButtonText = 'Gem ændringer';
        if (this.props.opretRediger === 'opret') {
            header = 'Tilmeld hold';
            saveButtonText = 'Tilmeld';
            if (this.props.venteliste) {
                header = 'Skriv dig på venteliste';
                saveButtonText = 'Skriv dig på venteliste';
            }
        }

        const dropDownsDisabled = (this.props.opretRediger === 'rediger' && getLoggedInBruger().rolle === BrugerRolleEnum.Administrator) || uniloginDataMangler;

        let beskrivelse = undefined;
        if (this.props.konkurrence.beskrivelse !== undefined && this.props.konkurrence.beskrivelse != null) {
            beskrivelse = (
                <div>
                    <h4 className='card-image-sub-header'>Bemærk</h4>
                    <KonkurrenceBeskrivelse beskrivelse={this.props.konkurrence.beskrivelse} />
                </div>
            );
        }

        return (
            <SectionGroup header={header}>
                <Form onSubmit={this.handleSubmit}>
                    <Section>
                        <div className='konkurrence-summary'>
                            <Row>
                                <Col md={3} className='card-image-wrapper'>
                                    <ImageFromBlob id={this.props.konkurrence.billedId} />
                                </Col>
                                <Col md={6}>
                                    <h2><Moment format='DD.MM.YY'>{String(this.props.konkurrence.startdato)}</Moment> - {this.props.konkurrence.titel}</h2>
                                    <p>{this.props.konkurrence.afviklingssted}</p>
                                    <p>{this.props.konkurrence.adresse} </p>
                                    <p>{this.props.konkurrence.postnummer} {this.props.konkurrence.bynavn}</p>

                                    {beskrivelse}
                                </Col>
                                {this.props.opretRediger === 'rediger' &&
                                    <Col md={3}>
                                        <Modal id='erDuSikkerFjernTilmelding' alert={true} excludeCancel={true} text='Ønsker du at fjerne denne tilmelding?' >
                                            <Button buttonType='primary' onClick={this.props.onTilmeldingDelete} dataDismiss='modal'>Fjern</Button>
                                        </Modal>
                                        <div className='pull-right'>
                                            <Button buttonType='primary' dataToggle='modal' dataTarget='#erDuSikkerFjernTilmelding'>Fjern tilmelding</Button>
                                        </div>
                                    </Col>
                                }
                            </Row>
                        </div>
                    </Section>
                    <Section>
                        <Row>
                            <Col md={3}>
                                <h3>Tilmelding</h3>
                            </Col>
                            <Col md={9}>
                                {this.getUniloginSection()}
                                <Row>
                                    <Col md={4}>
                                        <DropDownFormGroup
                                            errorMessages={this.props.validationResult.errorMessages}
                                            name='institutionsnummer'
                                            ingenValgtText='Vælg institution'
                                            items={institutioner}
                                            selectedValue={this.props.valgtInstitution.institutionsnummer}
                                            label='Skole/uddannelsessted*'
                                            onChange={this.props.onTilmeldingChanged}
                                            disabled={dropDownsDisabled}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <DropDownFormGroup
                                            errorMessages={this.props.validationResult.errorMessages}
                                            name='gruppeId'
                                            items={hold}
                                            selectedValue={this.props.tilmelding.hold === undefined ? undefined : this.props.tilmelding.hold.gruppeId}
                                            label='Hold/klasse*'
                                            ingenValgtText='Vælg hold'
                                            onChange={this.props.onTilmeldingChanged}
                                            disabled={dropDownsDisabled}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <DropDownFormGroup
                                            errorMessages={this.props.validationResult.errorMessages}
                                            name='opgavepakkeId'
                                            items={opgavepakker}
                                            selectedValue={this.props.tilmelding.opgavepakkeId}
                                            label='Konkurrencetype*'
                                            onChange={this.props.onTilmeldingChanged}
                                            ingenValgtText='Vælg konkurrencetype'
                                            disabled={dropDownsDisabled}
                                        />
                                    </Col>
                                </Row>
                                {this.getRemarksSection()}
                            </Col>
                        </Row>
                    </Section>
                    {this.props.opretRediger === 'rediger' &&
                        <Section id='tilmelding-laerere-section'>
                            <Row>
                                <Col md={3} className='tilmelding-laerere-col'>
                                    <h3 className='tilmelding-laerere-header'>Tilmeldte lærere</h3>
                                </Col>
                                <Col md={9} className='tilmelding-tilmeldte-laerer-col'>
                                    {tilmeldteLaerere}
                                </Col>
                            </Row>
                        </Section>
                    }
                    <Section id='tilmelding-laerere-section'>
                        <Row>
                            <Col md={3} className='tilmelding-laerere-header-col'>
                                <h3 className='tilmelding-laerere-header'>Inviterede lærere</h3>
                            </Col>
                            <Col md={9} id='tilmelding-laerere-col' className='tilmelding-inviterede-laerer-col' >
                                {inviteredeLaerere}
                                <Button buttonSize='lg' buttonType='secondary' onClick={this.props.onInvitationAdded}>
                                    Inviter en lærer
                                </Button>
                            </Col>
                        </Row>
                    </Section>

                    <ButtonSection validationErrors={this.props.validationResult.errorMessages}>
                        <Button className='spacer' buttonType='secondary' onClick={this.props.history.goBack}>Forrige</Button>
                        <SubmitButton isSubmitting={this.props.isSubmitting}>{saveButtonText}</SubmitButton>
                    </ButtonSection>

                </Form>
            </SectionGroup>
        );
    }
}

export default TilmeldHoldPresenter;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/tilmelding/TilmeldHoldPresenter.tsx